var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"p-b-10"},[_vm._v("拜访转化率分布")]),_c('div',{staticClass:"m-b-10",staticStyle:{"width":"100%","height":"280px"},attrs:{"id":"bottom_chart"}})])
}]

export { render, staticRenderFns }